
  import { Component, Prop, Vue } from 'vue-property-decorator'

  @Component
  export default class ItemSubGroup extends Vue {

    @Prop({
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        children: [],
      }),
    }) private readonly item: object = {}
  }
